module.exports = __webpack_public_path__ + "img/1.6aad3fe8.jpg";